import React from 'react';

export const Spots = (props: { className?: string }) => {
    return (
        <svg
            className={props.className}
            width='34'
            height='34'
            viewBox='0 0 34 34'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M3.79999 5.79992C3.79999 4.69536 4.69542 3.79993 5.79999 3.79993H13.8C14.9046 3.79993 15.8 4.69536 15.8 5.79993V28.1999C15.8 29.3045 14.9046 30.1999 13.8 30.1999H5.79999C4.69542 30.1999 3.79999 29.3045 3.79999 28.1999L3.79999 5.79992Z'
                fill='currentColor'
            />
            <path
                d='M18.2 5.80005C18.2 4.69548 19.0954 3.80005 20.2 3.80005H28.2C29.3046 3.80005 30.2 4.69548 30.2 5.80005V13.8C30.2 14.9046 29.3046 15.8 28.2 15.8H20.2C19.0954 15.8 18.2 14.9046 18.2 13.8V5.80005Z'
                fill='currentColor'
            />
            <path
                d='M18.2 20.2C18.2 19.0954 19.0954 18.2 20.2 18.2H28.2C29.3046 18.2 30.2 19.0954 30.2 20.2V28.2C30.2 29.3045 29.3046 30.2 28.2 30.2H20.2C19.0954 30.2 18.2 29.3045 18.2 28.2V20.2Z'
                fill='currentColor'
            />
        </svg>
    );
};

export default Spots;
